import { Header } from "@/components/Header.tsx";
import { useAppData } from "@/components/App.tsx";
import Chat from "@/components/Chat.tsx";
import { Login } from "@/components/Login.tsx";
import { History } from './History.tsx';
import { PasswordSet } from "./PasswordSet.tsx";
import { SettingsUI } from "./SettingsUI.tsx";
import { Welcome } from "./Welcome.tsx";


export function Layout() {
  const appData = useAppData();

  let UI = Chat;
  if (appData.isPasswordSet.value) UI = PasswordSet;
  else if (appData.path.endsWith("/welcome")) {
    UI = Welcome;

    if (typeof document !== "undefined" && typeof appData.user.value?.info == 'object') location.href = appData.siteURL;
  }
  // No user, show login UI
  else if (!appData.user.value) UI = Login;


  return <>
    <Header />
    <main>
      <UI />
    </main>
    <History />
    <SettingsUI />
  </>
}